import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { transformOrigins } from "../../imports";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import useGetMediaLocation from "../hooks/useGetMediaLocation";
import OutputCueBase from "./OutputCueBase";

import { cuesApi } from "../../imports";

export default function OutputCueStyles({ cue, cloud = false, children }) {
	const { projectId } = useParams();
	const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);
	const baseTheme = useSelector((state) =>
		cloud
			? state?.projects?.[projectId + "_themes"]?.[cue.theme]
			: cue.theme
			? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
			: state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);
	const baseThemeId = cue.theme ? cue.theme : selectedProject?.theme;
	const secondSelectors = [
		{
			name: "paddingX",
			group: "background",
			prefix: "px",
			ignore: [
				"social",
				"celebration",
				"image",
				"image_sequence",
				"webpage",
				"score",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"lower_third_animated",
				"animated_background",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "paddingY",
			group: "background",
			prefix: "py",
			ignore: [
				"social",
				"celebration",
				"image",
				"image_sequence",
				"webpage",
				"score",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"lower_third_animated",
				"animated_background",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "width",
			group: "background",
			prefix: "w",
			ignore: [
				"image",
				"image_sequence",
				"webpage",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"lower_third_animated",
				"animated_background",
				"celebration",
				"checklist",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "height",
			group: "background",
			prefix: "h",
			ignore: [
				"image",
				"image_sequence",
				"webpage",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"lower_third_animated",
				"animated_background",
				"celebration",
				"checklist",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "rounding",
			group: "background",
			prefix: "rounded",
			ignore: [
				"credits",
				"animated_background",
				"celebration",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "marginX",
			group: "position",
			prefix: "mx",
			ignore: [
				"image",
				"image_sequence",
				"webpage",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"animated_background",
				"celebration",
				"credits",
				// "checklist",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
		{
			name: "marginY",
			group: "position",
			prefix: "my",
			ignore: [
				"image",
				"image_sequence",
				"webpage",
				"big_time",
				"big_time_countdown",
				"big_time_countup",
				"big_time_to_tod",
				"animated_background",
				"celebration",
				"credits",
				// "checklist",
				"video",
				"map",
				"now_next_then",
				"slideshow",
				"custom_html",
				"rive",
				"solid_colour",
				"audio",
				"utility_pattern",
				"utility_time_of_day",
				"utility_speaker_timer",
			],
		},
	];

	return (
		<OutputCueBase cue={cue} cloud={cloud} id={cue.id}>
			<div
				style={{
					fontFamily: checkForOverride(
						baseTheme,
						cue.type,
						cue.preset,
						"font",
						"family"
					),
					clipPath: `inset(${cue?.crop?.top || 0}% ${cue?.crop?.right || 0}% ${
						cue?.crop?.bottom || 0
					}% ${cue?.crop?.left || 0}%)`,
				}}
				className={`flex flex-col transition-all duration-500 leading-tight ${
					cue.position || "mc"
				}

				${
					!["credits", "now_next_then","slideshow", "custom_html", "rive"].includes(cue.type)
						? "h-full"
						: ""
				}
				
			
            `}
			>
				<OutputCueTransitionLayer cue={cue} cloud={cloud}>
					<div
						style={{
							background:
								cue.type === "social" ||
								cue.type === "image" ||
								cue.type === "image_sequence" ||
								cue.type === "webpage" ||
								cue.type === "score" ||
								cue.type === "big_time" ||
								cue.type === "big_time_countdown" ||
								cue.type === "big_time_countup" ||
								cue.type === "big_time_to_tod" ||
								cue.type === "lower_third_animated" ||
								cue.type === "icon_with_message" ||
								cue.type === "image_with_message" ||
								cue.type === "animated_background" ||
								cue.type === "celebration" ||
								cue.type === "now_next_then" ||
								cue.type === "slideshow" ||
								cue.type === "audio" ||
								cue.type === "custom_html" ||
								cue.type === "rive" ||
								cue.type === "video" ||
								cue.type === "map" ||
								cue.type === "solid_colour" ||
								cue.type === "custom_html" ||
								cue.type === "progress" ||
								cue.customBackground === 'true' ||
								cue.customBackground === true ||
								cue.type.includes("utility_")
									? null
									: `${linearGradient(
											baseTheme,
											cue.type,
											cue.preset,
											"background",
											"colour"
									  )}`,
							boxShadow:
								cue.type === "social" ||
								cue.type === "image" ||
								cue.type === "image_sequence" ||
								cue.type === "webpage" ||
								cue.type === "score" ||
								cue.type === "big_time" ||
								cue.type === "big_time_countdown" ||
								cue.type === "big_time_countup" ||
								cue.type === "big_time_to_tod" ||
								cue.type === "lower_third_animated" ||
								cue.type === "icon_with_message" ||
								cue.type === "image_with_message" ||
								cue.type === "animated_background" ||
								cue.type === "celebration" ||
								cue.type === "audio" ||
								cue.type === "custom_html" ||
								cue.type === "rive" ||
								cue.type === "video" ||
								cue.type === "map" ||
								cue.type === "solid_colour" ||
								cue.type === "custom_html" ||
								cue.type === "progress" ||
								cue.customBackground === "true" ||
								cue.customBackground === true ||
								cue.type.includes("utility_")
									? null
									: glow(
											baseTheme,
											cue.type,
											cue.preset,
											"background",
											"glowBlur"
									  ),
							transform: `translate(${cue.offsetX || 0}vw, ${
								cue.offsetY || 0
							}vh) scale(${cue.scale / 100 || 1})`,
							rotate: `${cue.rotate || 0}deg`,
							transformOrigin: transformOrigins[cue.position || "mc"],
							transitionDuration: "0ms",
							// background: `linear-gradient(${baseTheme.background.degrees}deg, ${baseTheme.background.colour} 0%, ${baseTheme.background.colour2} 100%)`,

							borderTop: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[0] === "1"
									? cue.type === "image" ||
									cue.type === "image_sequence" ||
									  cue.type === "social" ||
									  cue.type === "score" ||
									  cue.type === "big_time" ||
									  cue.type === "big_time_countdown" ||
									  cue.type === "big_time_countup" ||
									  cue.type === "big_time_to_tod" ||
									  cue.type === "lower_third_animated" ||
									  cue.type === "icon_with_message" ||
									  cue.type === "image_with_message" ||
									  cue.type === "animated_background" ||
									  cue.type === "celebration" ||
									  cue.type === "webpage" ||
									  cue.type === "now_next_then" ||
									  cue.type === "slideshow" ||
									  cue.type === "audio" ||
									  cue.type === "custom_html" ||
									  cue.type === "rive" ||
									  cue.type === "video" ||
									  cue.type === "map" ||
									  cue.type === "solid_colour" ||
									  cue.type === "custom_html" ||
									  cue.type === "progress" ||
									  cue.type.includes("utility_")
										? 0
										: baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderBottom: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[1] === "1"
									? cue.type === "image" ||
									cue.type === "image_sequence" ||
									  cue.type === "score" ||
									  cue.type === "big_time" ||
									  cue.type === "big_time_countdown" ||
									  cue.type === "big_time_countup" ||
									  cue.type === "big_time_to_tod" ||
									  cue.type === "lower_third_animated" ||
									  cue.type === "icon_with_message" ||
									  cue.type === "image_with_message" ||
									  cue.type === "animated_background" ||
									  cue.type === "celebration" ||
									  cue.type === "social" ||
									  cue.type === "now_next_then" ||
									  cue.type === "slideshow" ||
									  cue.type === "audio" ||
									  cue.type === "custom_html" ||
									  cue.type === "rive" ||
									  cue.type === "video" ||
									  cue.type === "map" ||
									  cue.type === "solid_colour" ||
									  cue.type === "custom_html" ||
									  cue.type === "progress" ||
									  cue.type.includes("utility_")
										? 0
										: baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderLeft: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[2] === "1"
									? cue.type === "image" ||
									cue.type === "image_sequence" ||
									  cue.type === "score" ||
									  cue.type === "big_time" ||
									  cue.type === "big_time_countdown" ||
									  cue.type === "big_time_countup" ||
									  cue.type === "big_time_to_tod" ||
									  cue.type === "lower_third_animated" ||
									  cue.type === "icon_with_message" ||
									  cue.type === "image_with_message" ||
									  cue.type === "animated_background" ||
									  cue.type === "social" ||
									  cue.type === "now_next_then" ||
									  cue.type === "slideshow" ||
									  cue.type === "audio" ||
									  cue.type === "custom_html" ||
									  cue.type === "rive" ||
									  cue.type === "video" ||
									  cue.type === "map" ||
									  cue.type === "solid_colour" ||
									  cue.type === "custom_html" ||
									  cue.type === "progress" ||
									  cue.type.includes("utility_")
										? 0
										: baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
							borderRight: `${
								checkForOverride(
									baseTheme,
									cue.type,
									cue.preset,
									"border",
									"sides"
								)[3] === "1"
									? cue.type === "image" ||
									cue.type === "image_sequence" ||
									  cue.type === "score" ||
									  cue.type === "big_time" ||
									  cue.type === "big_time_countdown" ||
									  cue.type === "big_time_countup" ||
									  cue.type === "big_time_to_tod" ||
									  cue.type === "lower_third_animated" ||
									  cue.type === "icon_with_message" ||
									  cue.type === "image_with_message" ||
									  cue.type === "animated_background" ||
									  cue.type === "social" ||
									  cue.type === "now_next_then" ||
									  cue.type === "slideshow" ||
									  cue.type === "audio" ||
									  cue.type === "custom_html" ||
									  cue.type === "rive" ||
									  cue.type === "video" ||
									  cue.type === "map" ||
									  cue.type === "solid_colour" ||
									  cue.type === "custom_html" ||
									  cue.type === "progress" ||
									  cue.type.includes("utility_")
										? 0
										: baseTheme.border.size
									: 0
							}vw ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"style"
							)} ${checkForOverride(
								baseTheme,
								cue.type,
								cue.preset,
								"border",
								"colour"
							)}`,
						}}
						className={`${
							cue.type === "social" ||
							cue.type === "score" ||
							cue.type === "big_time" ||
							cue.type === "big_time_countdown" ||
							cue.type === "big_time_countup" ||
							cue.type === "big_time_to_tod" ||
							cue.type === "lower_third_animated"
								? ""
								: `${baseThemeId}_${cue.type} ${cue.type}`
						} flex transition-all duration-500
								${cue.type === "ticker" ? "flex-row" : "flex-col"}
								${cue.type === "image" && "w-screen h-screen"}
								${cue.type === "custom_html" && "w-screen h-screen"}
								 ${cue.type === "checklist" && "justify-center"}
								${cue.type === "animated_background" && "w-screen h-screen"}
								${
									["credits", "now_next_then","slideshow", "custom_html"].includes(cue.type) &&
									(cue.status === "coming" ||
										cue.status === "going" ||
										cue.status === "cuedoff") &&
									"w-screen h-screen"
								}
								${
									["credits", "now_next_then","slideshow", "custom_html"].includes(cue.type) &&
									cue.status === "onair" &&
									"w-screen h-screen"
								}

								${cue.type === "checklist" && `h-${baseTheme?.["checklist"]?.height || "auto"}`}


								${secondSelectors
									.map((s) => {
										if (s.ignore && s.ignore.includes(cue.type)) return null;

										return `${s.prefix}-${checkForOverride(
											baseTheme,
											cue.type,
											cue.preset,
											s.group,
											s.name
										)} `;
									})
									.join("")}
				
                `}
					>
						{children}
					</div>
				</OutputCueTransitionLayer>
			</div>
		</OutputCueBase>
	);
}

export const OutputCueTransitionLayer = ({ cue, cloud = false, children }) => {
	const { projectId } = useParams();

	const isPreview = useLocation().pathname.includes("/preview/");
	const mediaLocation = useGetMediaLocation();
	const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);
	const baseTheme = useSelector((state) =>
		cloud
			? state?.projects?.[projectId + "_themes"]?.[cue.theme]
			: cue.theme
			? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
			: state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);

	let transitionStart;
	let transitionEnd;

	let transitionDuration =
		cue.status === "cued" || cue.status === "offair" || cue.status === "ready"
			? "duration-0 opacity-0"
			: `duration-${baseTheme?.transition?.duration}`;

	let transition =
		cue.transition && cue.transition !== "use-theme"
			? cue.transition
			: checkForOverride(baseTheme, cue.type, cue.preset, "transition", "type");

	if (
		cue.type === "lower_third_animated" ||
		cue.type === "icon_with_message" ||
		cue.type === "image_with_message"
	) {
		transition = "animate";
		// transitionDuration = "duration-1500";
	}

	if (cue.type.includes("utility_")) {
		transition = "fade";
		transitionDuration = "100";
	}

	if (cue.type.includes("image_sequence")) {
		transition = "animate";
	}

	if (cue.type.includes("rive")) {
		transition = "animate";
		transitionDuration = "duration-1500";
	}

	if (cue.type.includes("custom_html")) {
		transition = "none-in-fade-out";
	}

	if (true)
		switch (transition) {
			case "fade":
				transitionStart = `opacity-0 transition ${transitionDuration}`;
				transitionEnd = `opacity-100 transition ${transitionDuration}`;
				break;
			case "animate":
				transitionStart = `opacity-95 transition-color ${transitionDuration}`;
				transitionEnd = `opacity-100 transition-color ${transitionDuration}`;
				break;
			case "slide":
				switch (cue.position) {
					case "tc":
						transitionStart = `h-0 translate-y-nh100 transition-transform ${transitionDuration}`;
						transitionEnd = `translate-y-0 transition-transform ${transitionDuration}`;
						break;

					case "tl":
					case "ml":
					case "bl":
						transitionStart = `h-0 translate-x-nw100 transition-transform ${transitionDuration}`;
						transitionEnd = `translate-x-0 transition-transform ${transitionDuration}`;
						break;

					case "tr":
					case "mr":
					case "br":
						transitionStart = `h-0 translate-x-w100 transition-transform ${transitionDuration}`;
						transitionEnd = `translate-x-0 transition-transform ${transitionDuration}`;
						break;

					case "bc":
					case "mc":
						transitionStart = `h-0 translate-y-h100 transition-transform ${transitionDuration}`;
						transitionEnd = `translate-y-0 transition-transform ${transitionDuration}`;
						break;

					default:
						transitionStart = `h-0 translate-y-h100 transition-transform ${transitionDuration}`;
						transitionEnd = `translate-y-0 transition-transform ${transitionDuration}`;
						break;
				}
				break;

			case "slide_fade":
				switch (cue.position) {
					case "tc":
						transitionStart = `opacity-0 h-0 translate-y-nh100 transition-all ${transitionDuration}`;
						transitionEnd = `opacity-100 translate-y-0 transition-all ${transitionDuration}`;
						break;

					case "tl":
					case "ml":
					case "bl":
						transitionStart = `opacity-0 h-0 translate-x-nw100 transition-all ${transitionDuration}`;
						transitionEnd = `opacity-100 translate-x-0 transition-all ${transitionDuration}`;
						break;

					case "tr":
					case "mr":
					case "br":
						transitionStart = `opacity-0 h-0 translate-x-w100 transition-all ${transitionDuration}`;
						transitionEnd = `opacity-100 translate-x-0 transition-all ${transitionDuration}`;
						break;

					case "bc":
					case "mc":
						transitionStart = `opacity-0 h-0 translate-y-h100 transition-all ${transitionDuration}`;
						transitionEnd = `opacity-100 translate-y-0 transition-all ${transitionDuration}`;
						break;

					default:
						transitionStart = `opacity-0 h-0 translate-y-h100 transition-all ${transitionDuration}`;
						transitionEnd = `opacity-100 translate-y-0 transition-all ${transitionDuration}`;
						break;
				}
				break;

			case "wipe_top_bottom":
				transitionStart = `inset-t-b opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "wipe_left_right":
				transitionStart = `inset-l-r opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "wipe_top":
				transitionStart = `inset-b opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "wipe_bottom":
				transitionStart = `inset-t opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "wipe_left":
				transitionStart = `inset-r opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "wipe_right":
				transitionStart = `inset-l opacity-100 transition-all ${transitionDuration}`;
				transitionEnd = `inset-none transition-all ${transitionDuration}`;
				break;

			case "scale":
			case "scale_fade":
				const startOpacity = transition === "slide" ? "100" : "0";
				switch (cue.position) {
					case "tc":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0 origin-top`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100 origin-top`;
						break;

					case "tl":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0  origin-top-left`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100  origin-top-left`;
						break;
					case "ml":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0 origin-left`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100 origin-left`;
						break;
					case "bl":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0 origin-bottom-left`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100 origin-bottom-left`;
						break;

					case "tr":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0 origin-top-right`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100 origin-top-right`;
						break;
					case "mr":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0 origin-right`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100 origin-right`;
						break;
					case "br":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0  origin-bottom-right`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100  origin-bottom-right`;
						break;

					case "bc":
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0  origin-bottom`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100  origin-bottom`;
						break;

					default:
						transitionStart = `opacity-${startOpacity} transition-all ${transitionDuration} transform scale-0  origin-center`;
						transitionEnd = `opacity-100 transition-all ${transitionDuration} transform scale-100  origin-center`;
						break;
				}
				break;

			case "blur_fade":
				transitionStart = `opacity-0 transition ${transitionDuration} filter blur-2xl`;
				transitionEnd = `opacity-100 transition ${transitionDuration} filter blur-none`;
				break;

			case "none":
				transitionStart = `opacity-0 transition-all duration-0`;
				transitionEnd = `opacity-100 transition-all duration-0`;
				break;

			case "none-in-fade-out":
				transitionStart = `opacity-0 duration-1500`;
				transitionEnd = `opacity-100 duration-0`;
				break;

			default:
				transitionStart = `opacity-0 transition-all duration-0`;
				transitionEnd = `opacity-100 transition-all duration-0`;
				break;
		}

	return (
		<div
			id={`transition_end_parent`}
			className={`transform-gpu ease-in-out h-auto  ${
				isPreview && cue.status === "cued"
					? "opacity-100"
					: cue.status === "coming" ||
					  cue.status === "onair" ||
					  (cue.status === "cuedoff" && !isPreview)
					? transitionEnd
					: transitionStart
			} 
			
			${cue.type === "video" && "w-full h-full"}
			${cue.type === "image" && "w-full h-full"}
			${cue.type === "image_sequence" && "w-full h-full"}
			${cue.type === "animated_background" && "w-full h-full"}
			${cue.type === "lower_third_animated" && "w-full"}
			
			${cue.type === "ticker" && "w-full "}
			${cue.type === "interaction_join" && "w-"}
			${cue.type === "interaction_current_question" && "w-full"}
			${cue.type === "cloud_interaction_poll" && "w-full "}


			${
				cue.type === "lower_third" &&
				`w-${baseTheme?.["lower_third"]?.width || "auto"}`
			}
			${cue.type === "checklist" && `w-${baseTheme?.["checklist"]?.width || "auto"}`}
			
			
			
			
			`}
			onTransitionEnd={(e) => {
				// MAKE SURE ONLY THIS PARENT ITEM CAN UPDATE STATUS ON END OF TRANSITION
				if (e.target?.id !== "transition_end_parent") return null;

				if (cue.status === "coming") {
					cuesApi.updateCue(cue.id, projectId, { status: "onair" });
				} else if (cue.status === "going") {
					if ((cue.type === "time" || cue.type === "big_time") && !cue.paused) {
						return cuesApi.updateCue(cue.id, projectId, {
							timeLeft: cue.timerType === "countdown" ? cue.durationMS : 0,
							status: "ready",
						});
					}
					if (cue.type === "video") {
						return cuesApi.updateCue(cue.id, projectId, {
							currentTime: 0,
							status: "ready",
						});
					} else {
						cuesApi.updateCue(cue.id, projectId, { status: "ready" });
					}
				}
			}}
		>
			{cue.useCustomImage && cue.type === "lower_third" && (
				<div
					className={`
					
					image_key absolute  w-screen h-screen

					${cue.position === "bl" && "-bottom-0"}
					${cue.position === "br" && "-bottom-0 -right-0"}
					
					`}
					style={{
						backgroundImage: `url(${mediaLocation}${cue.customImage})`,
						backgroundSize: "contain",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
					}}
				></div>
			)}
			{children}
		</div>
	);
};
